"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContent = exports.StyledDivider = exports.StyledTitleContainer = exports.StyledElement = exports.StyledOptions = exports.StyledTitle = exports.StyledOptionsContainer = exports.StyledPositionContainer = void 0;
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
const { rem } = ui_common_components_1.utils;
exports.StyledPositionContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  cursor: pointer;

  ${({ theme }) => (0, styled_components_1.css) `
    padding: ${rem(theme.Spacing.Size.Small)} ${rem(theme.Spacing.Size.XSmall)};
    gap: ${rem(theme.Spacing.Size.XSmall)};
  `}
`;
exports.StyledOptionsContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XXSmall)};
`;
exports.StyledTitle = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
`;
exports.StyledOptions = styled_components_1.default.div `
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-gap: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};

  button {
    padding-left: 15px;
    justify-content: flex-start;
  }
`;
exports.StyledElement = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: ${rem(32)};
  padding: 0 ${rem(15)};
  gap: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
`;
exports.StyledTitleContainer = styled_components_1.default.span `
  width: 100%;
  display: flex;
  padding-bottom: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
  gap: ${({ theme }) => rem(theme.Spacing.Size.XXSmall)};
`;
exports.StyledDivider = styled_components_1.default.hr `
  width: 100%;
  border: none;
  border-top: 1px solid ${({ theme }) => theme.Color.Neutrals.Border};
  margin: ${({ theme }) => rem(theme.Spacing.Size.Small)} 0;
`;
exports.StyledContent = styled_components_1.default.div `
  width: 100%;
`;
//# sourceMappingURL=Position.styles.js.map